<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('tab_title_statistics') || '预算执行分析'"
        name="base"
      >
        <ReportIndex />
      </el-tab-pane>
      <el-tab-pane :label="$l('tab_title_sales_list') || '业务人员分析'" name="orderList">
        <page-table />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ReportIndex from './report'
import PageTable from './table'
export default {
  name: 'financial-finRep-budgetAnalysis',
  components: {
    ReportIndex,
    PageTable
  },
  data() {
    return {
      activeName: 'base'
    }
  }
}
</script>

<style></style>
